import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Generic, presentational message-modal shell: a title, a body and a single close button. It holds
 * NO i18n and NO dialog logic — the caller passes already-resolved strings and handles `closed`.
 * A feature builds its own thin modal on top of this (e.g. ModalLanguageLoadErrorComponent), which
 * is where the literal translation keys + `| translate` pipe live so they flow through the normal
 * extraction / spreadsheet workflow.
 */
@Component({
    selector: 'app-smash-message-modal',
    standalone: true,
    imports: [],
    templateUrl: './smash-message-modal.component.html',
    styleUrls: ['./smash-message-modal.component.scss'],
})
export class SmashMessageModalComponent {
    @Input() title = '';
    @Input() description = '';
    @Input() closeLabel = '';
    // Optional primary action (e.g. "Reload"). When primaryLabel is empty the footer renders exactly
    // as before — a single close button — so existing consumers (the language modal) are unchanged.
    @Input() primaryLabel = '';
    @Output() closed = new EventEmitter<void>();
    @Output() primaryAction = new EventEmitter<void>();

    /** True when a primary action is configured. Drives the close button's red/white styling. */
    get hasPrimaryAction(): boolean {
        return !!this.primaryLabel;
    }
}
